import { gql } from "@apollo/client";

export const SAVE_STOCK_CATEGORY_STOCK = gql`
  mutation SAVE_STOCK_CATEGORY_STOCK(
    $id: ID
    $stockCategoryId: ID
    $productId: ID
    $name: String
    $number: String
    $asin: String
    $barcode: String
    $unitCost: Float
    $initialQty: Int
  ) {
    saveStockCategoryStock(
      id: $id
      stockCategoryId: $stockCategoryId
      productId: $productId
      name: $name
      number: $number
      asin: $asin
      barcode: $barcode
      unitCost: $unitCost
      initialQty: $initialQty
    ) {
      stockCategory {
        id
        name
        stocks {
          id
          name
          number
          asin
          barcode
          unitCost
          initialQty
          product {
            id
            number
          }
        }
      }
      stock {
        id
        name
        number
        asin
        barcode
        unitCost
        initialQty
        latestQty
      }
    }
  }
`;

export const FETCH_STOCK_SHIPMENT_LINES = gql`
  query FETCH_STOCK_SHIPMENT_LINES($stockId: ID!) {
    stockShipmentLines(stockId: $stockId) {
      id
      qty
      shipment {
        id
        date
        refId
        refName
        refType
        moveType
        state
        toLocationId
      }
    }
  }
`;
